export const landscape = {
	name: 'Untitled Landscape Template',
	variant: 'design',
	json: {
		width: 1200,
		height: 627,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Digital',
		'0:Distribution:Social',
		'0:Format:Post',
		'0:Format:Ad',
		'0:Layout:Landscape',
		'0:Dimensions:1200x627',
		'0:Network:Facebook',
		'0:Network:LinkedIn',
		'0:Network:X',
		'0:Network:Instagram',
	],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: 'landscape',
			},
			canBeResized: true,
		},
	},
};

export default landscape;
